module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAJ1JREFUSEvtlMEKgzAQRGfAb+6hClZq/e0xkRbEg7ubsuDBXHJIMi8zE0IkDybr4waYCV8jIkkPAB3JxbzyYYPLgaQngA+AieQrAnEBqqCkscxVPARxA1ohIUALJAz4QvpS+gygt4pvBQwA3ikASbXorXCSk/WiQg6i4hXuBrSIuwGSfqW6YtnH5nKQ/lVYRZ6tuxzcgH8SMM+md7ACZGA6GRokhIYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more.png
// module id = MprZ
// module chunks = 26